import React from 'react';
import { InfoOutlined } from '@ant-design/icons';
import './Icon.less';

const InfoIcon = () => {
  return (
    <div className='dialog-info-icon'>
      <div className='dialog-info-icon-info'>
        <InfoOutlined className='dialog-info-icon-info__icon' />
      </div>
    </div>
  );
};

export default InfoIcon;
